import styled from "styled-components";
import bgbImg from "../../assets/images/background2.png";
import bgbImg1 from "../../assets/images/backgroundimg3.png";
import bgbImg3 from "../../assets/images/cityImg.png";
import bgbImg4 from "../../assets/images/maxIcon.png";
import bgbImg5 from "../../assets/images/bannerBackground.svg";

export const AboutSdkWrapper = styled.div`
font-family: 'Rubik', sans-serif;
letter-spacing: -0.5px;

.services{
  padding-bottom: 60px;
     &>h2{
        color: #000;
   
     }
}
.section1{
  background-image: url(${bgbImg});
  background-repeat: no-repeat;
  background-position: bottom center;
  margin-bottom: 120px;
  .perfectSdk{
    &>div.flex{
      max-width: 918px;
      margin-inline: auto;
      &> div{
      flex: 1 1 33%;
      &>.mobileImg{
        width: 100%;
      }
      p{
        display: block;
        text-align: center;
        margin-block: 20px 80px;
        font-weight: 600;
      }
    }
    }
  
    
  }
}
.section2{
  .container{
    .box{
      gap: 30px;
      flex-wrap: wrap;
      &>div{
        flex: 1 1 450px;

        border-radius: 20px;
        padding: 60px 30px;
        background-color: #FFFFFF;
border: 1px solid #B6B6B6;
position: relative;
margin-bottom: 60px;

        &.left{
          border: 1px solid #FFE4D3;
          background-color: #FFE4D3;
        }
        h2{
          font-size: 45px;
          line-height: 50px;
          margin-bottom: 20px;
        }
        p{
          font-size: 20px;
          margin-bottom: 25px;
        }
        h3{
          font-size: 20px;
          margin-bottom: 20px;
          position: relative;
          z-index: 1;
        }
        ul{
          position: relative;
          z-index: 1;
        }
        li{
          line-height: 35px;
          color: #000;
        }
        img{
          position: absolute;
          bottom: -42px;
          right: 0px;
        }
      }
    }
  }
}
.cardbox2{
  position: relative;
  top: 65px;
}
.section3{
  background-image: url(${bgbImg1}),url(${bgbImg3});
  min-height: 800px;
  background-repeat: no-repeat,no-repeat;
  background-position: center 500px, center 378px;
  padding-top: 80px;
  .container{
    .box
    {
      background: #FFFFFF url(${bgbImg4});
      background-repeat: no-repeat;
box-shadow: 0px 3px 50px #00000017;
border-radius: 20px;
min-height: 591px;
display: flex;
align-items: center;
.right{
  max-width: 330px;
  margin-left: auto;
  padding-inline: 40px;
}

    }
    .cardBox{
      padding-inline: 40px;
      position: relative;
      top: -60px;
    }
  }

  .newBox{
    flex-wrap: wrap;
    padding-block: 60px;
    gap: 40px;
    justify-content: space-between;
    .left{
      flex: 1 1;
      gap: 40px;
      flex-wrap:  wrap;
    }
    .right{
      li{
        color: #000;
      }
    }
  }
  .bannerbox{
    background-image: url(${bgbImg5});
  min-height: 369px;
  background-repeat: no-repeat;
  background-color: #FFECE0;
  border-radius: 20px;

  background-position-y: bottom;
  background-position-x: left;
  display: flex;
  justify-content: right;
  align-items: center;
  padding-inline: 40px;
  margin-top: 40px;
  margin-bottom: 60px;
  &>div{
    max-width: 550px;
  }

  }
}
@media screen and (max-width: 480px){
  .section2 .container .box>div img{
    max-width: 240px;
  }
.section3{
  .container .box .right{
    p,h2{
      color: #fff !important;
    }
  }
}
}
`;

export const CardBox = styled.div`
display: flex;
justify-content: center;
align-items: center;
gap: 60px 30px;
flex-wrap: wrap;
&.imgType1{
  gap: 40px 30px;
}
&.layout1{
  gap: 50px 20px;
   &>div{
    flex: 1 1 160px;
    min-width: 160px;
   
   }
   &.layout2{
  
    &>div{
      padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  .img{
  left: 20px;
  }
    }
 
   }
}


`;

 export const CardWrapper = styled.div`
     background: ${({ bgcolor }) => bgcolor || '#F0F5FF'};
  border-radius: 20px;
  position: relative;
  padding: 62px 37px 37px;
  flex: 1 1 320px;
  min-width:320px;
  &>.img{
   position: absolute;
   left: 37px;
   top: -35px;
   width: 70px;
   height: 70px;
   background: #0E5EEA;
   display: flex;
   justify-content: center;
   align-items: center;
box-shadow: 0px 0px 20px #00000012;
border-radius: 20px;

&>img{
    width: 25px;
}


  }
  h3{
    font-size: 18px;
    margin-bottom: 10px;
}
p{
    font-size: 15px;
    line-height: 20px;
}
&.imgType1{
  padding: 38px 20px 20px 20px;
  .img{
    width: 46px;
    height: 46px;
    top: -23px;
    left: 20px;
    background-color: transparent;
    border: 0;
    img{
      width: 100%;
    }
  }
}
&.white{
  background: #FFFFFF;
box-shadow: 0px 3px 20px #00286F1F;
}
&.layout1{

}
 `

export  const BannerWrapper = styled.div`

margin-top: 100px;
max-width: 1240px;
margin-inline: auto;
padding-inline: 20px;

&>div{
  height: 100%;

  height: 343px;
background: #E7F7E0;
border-radius: 20px;
gap: 0px;
margin-bottom: 100px;
}
.left{
  max-width: 350px;
  h2{
    margin-bottom: 22px;
    font-size: 45px;
  }
  p{
    font-size: 20px;
    line-height: 30px;
  
  }
}
.middle{
  max-width: 431px;
  img{
    width: 100%;
    position: relative;
    top: -8px;
  }
}
.right{
  max-width: 410px;
  li{
    color: #000;
    font-weight: 600;
    line-height: 40px;
  }
}
@media screen and (max-width: 992px){
  &>div{
  flex-direction: column;
  height: auto;
  padding: 40px;
  gap: 30px;
  .left{
    text-align: center;
   max-width: 600px;
  }
  }
}
`;

 export const ButtonsGroups = styled.div`
 display: flex;
 justify-content: center;
 gap: 8px;
 max-width: 440px;
 margin-block: 30px;
 flex-wrap: wrap;
 white-space: nowrap;
 flex: 1 1 100%;
 .button-outline.btn1{
  background: transparent linear-gradient(261deg, #0444B4 0%, #0E5EEA 100%) 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #0E5EEA82;
border-radius: 10px;
flex: 1 1 40%;
padding: 0 20px !important;
 }
 .button-outline.btn2{
  padding: 0 20px !important;
  background-color: #C6D9FF;
  border-radius: 10px;
  color: #000;
  flex: 1 1 40%;
  &:hover{
    background-color:rgb(101, 151, 253);
  }
 }
`;